/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { adDesignIndex } from '../../axios/adDesignIndex'
import type { AdDesignIndexError, AdDesignIndexPathParams, AdDesignIndexResponse } from '../../types/AdDesignIndex'

export const adDesignIndexQueryKey = (organisation: AdDesignIndexPathParams['organisation']) =>
	[{ url: '/organisations/:organisation/ad-designs', params: { organisation } }] as const

export type AdDesignIndexQueryKey = ReturnType<typeof adDesignIndexQueryKey>

/** @see backend/nexus/modules/Organisation/Http/Controllers/AdDesignController.php AdDesignController::index */
export function adDesignIndexQueryOptions(
	organisation: AdDesignIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		AdDesignIndexResponse,
		AxiosError<AdDesignIndexError>,
		AdDesignIndexResponse,
		AdDesignIndexQueryKey
	>({
		queryKey: adDesignIndexQueryKey(organisation),
		queryFn: ({ signal }) => adDesignIndex(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/AdDesignController.php AdDesignController::index */
export function useAdDesignIndex<TSelectData = AdDesignIndexResponse>(
	organisation: AdDesignIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					AdDesignIndexResponse,
					AxiosError<AdDesignIndexError>,
					TSelectData,
					AdDesignIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<AdDesignIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...adDesignIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/AdDesignController.php AdDesignController::index */
export function useAdDesignIndexSuspense<TSelectData = AdDesignIndexResponse>(
	organisation: AdDesignIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					AdDesignIndexResponse,
					AxiosError<AdDesignIndexError>,
					TSelectData,
					AdDesignIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<AdDesignIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...adDesignIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
